import { Tooltip } from '#app/components/Tooltip/Tooltip.js';
import { VerifiedGreenGradientIcon } from '@contra/icons/icons';
import { styled } from 'styled-components';

const TooltipContainer = styled.div`
  cursor: default;
  display: flex;

  div {
    cursor: default;
    display: flex;
  }
`;

export const VerifiedExpertListBadge = ({
  size = 16,
}: {
  readonly size?: number;
}) => {
  return (
    <TooltipContainer>
      <Tooltip
        content="Verified Expert Program on Contra"
        width="auto"
      >
        <VerifiedGreenGradientIcon
          aria-label="Verified Expert Program badge"
          size={size}
        />
      </Tooltip>
    </TooltipContainer>
  );
};
